import _objectWithoutPropertiesLoose from "@babel/runtime/helpers/esm/objectWithoutPropertiesLoose";
import _inheritsLoose from "@babel/runtime/helpers/esm/inheritsLoose";
var _excluded = ["area", "alignX", "alignY", "posX", "posY", "spanX", "spanY", "style", "className"];
import React from 'react';
import pt from 'prop-types';
import { Box, BreakpointContext, breakpointPropSwitch } from '..';
import { appendHtmlClass, extendProps, responsivePropType } from '../../js/util';
import './_index.scss';
var GridItem = /*#__PURE__*/function (_React$Component) {
  _inheritsLoose(GridItem, _React$Component);
  function GridItem() {
    var _this;
    for (var _len = arguments.length, args = new Array(_len), _key = 0; _key < _len; _key++) {
      args[_key] = arguments[_key];
    }
    _this = _React$Component.call.apply(_React$Component, [this].concat(args)) || this;
    _this.DEFAULT_CLASS = 'grid-item';
    return _this;
  }
  var _proto = GridItem.prototype;
  _proto.getResponsiveValue = function getResponsiveValue(options) {
    return breakpointPropSwitch(options, this.context);
  };
  _proto.getEnumStyle = function getEnumStyle(prop, name) {
    var _ref;
    if (!prop) return {};
    var value = this.getResponsiveValue(prop);
    return _ref = {}, _ref[name] = value, _ref;
  };
  _proto.getSpanStyle = function getSpanStyle(prop, isVertical) {
    if (isVertical === void 0) {
      isVertical = false;
    }
    if (!prop) return {};
    var value = this.getResponsiveValue(prop);
    if (value === null) value = 1;
    value = "span " + value;
    return isVertical ? {
      gridRowEnd: value
    } : {
      gridColumnEnd: value
    };
  };
  _proto.getStyle = function getStyle(style, area, alignX, alignY, posX, posY, spanX, spanY) {
    return Object.assign(typeof style == 'object' ? style : {}, this.getEnumStyle(area, 'gridArea'), this.getEnumStyle(alignX, 'justifySelf'), this.getEnumStyle(alignY, 'alignSelf'), this.getEnumStyle(posX, 'gridColumnStart'), this.getEnumStyle(posY, 'gridRowStart'), this.getSpanStyle(spanX), this.getSpanStyle(spanY, true));
  };
  _proto.render = function render() {
    var _this$props = this.props,
      area = _this$props.area,
      alignX = _this$props.alignX,
      alignY = _this$props.alignY,
      posX = _this$props.posX,
      posY = _this$props.posY,
      spanX = _this$props.spanX,
      spanY = _this$props.spanY,
      style = _this$props.style,
      className = _this$props.className,
      rest = _objectWithoutPropertiesLoose(_this$props, _excluded);
    var areaStyle = this.getStyle(style, area, alignX, alignY, posX, posY, spanX, spanY);
    var areaClass = appendHtmlClass(className, this.DEFAULT_CLASS);
    return /*#__PURE__*/React.createElement(Box, Object.assign({
      style: areaStyle,
      className: areaClass
    }, rest));
  };
  return GridItem;
}(React.Component);
GridItem.contextType = BreakpointContext;
Object.assign(GridItem, extendProps(Box, ['className', 'id', 'children', 'width', 'height', 'border', 'borderTop', 'borderBottom', 'borderLeft', 'borderRight', 'padding', 'paddingTop', 'paddingBottom', 'paddingLeft', 'paddingRight', 'margin', 'marginTop', 'marginBottom', 'marginLeft', 'marginRight', 'mask', 'shadow', 'corner', 'as'], {
  area: responsivePropType.bind(this, pt.string),
  alignX: responsivePropType.bind(this, pt.oneOf(['start', 'end', 'center', 'stretch'])),
  alignY: responsivePropType.bind(this, pt.oneOf(['start', 'end', 'center', 'stretch'])),
  posX: responsivePropType.bind(this, pt.oneOfType([pt.number, pt.string])),
  posY: responsivePropType.bind(this, pt.oneOfType([pt.number, pt.string])),
  spanX: responsivePropType.bind(this, pt.number),
  spanY: responsivePropType.bind(this, pt.number)
}, {
  spanX: 1,
  spanY: 1
}));
export default GridItem;